const SCREEN_DIMENSIONS = {
  mobile: 767,
  tablet: 1024,
};

export default SCREEN_DIMENSIONS;
